import { createAction } from 'redux-actions';

const ns = 'invoiceFilterHistory';

export const setInvoiceFilter = createAction(`${ns}/SET_INVOICE_FILTER`);
export const resetInvoiceFilter = createAction(`${ns}/RESET_INVOICE_FILTER`);
